if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // First, show all media elements
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove("hidden");
        });
        
        // Then hide all except the active one
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.add("hidden");
        });
        
        // Ensure the active media is visible
        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        if (activeMedia && activeMedia.classList.contains("hidden")) {
          activeMedia.classList.remove("hidden");
        }
      }
    }
  );
}
